import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const WarningIcon = (props: IconProps) => (
  <Icon width="144px" height="150px" viewBox="0 0 144 150" {...props}>
    <ellipse
      cx="71.9438"
      cy="72.9911"
      fill="#FBDADA"
      opacity="0.5"
      rx="69.5954"
      ry="69.8661"
    />
    <path
      fill="#F6B5B5"
      d="m107.927 51.3284-6.845-6.8716-27.1369 27.2429-27.1374-27.2429-6.8451 6.8716L67.1 78.5714 39.9626 105.814l6.8451 6.872 27.1374-27.243 27.1369 27.243 6.845-6.872-27.1369-27.2426 27.1369-27.243Z"
    />
    <path
      fill="#E94545"
      d="m106.149 47.757-6.8454-6.8716-27.1374 27.2429-27.1373-27.2429-6.8451 6.8716L65.3212 75l-27.1374 27.243 6.8451 6.872 27.1373-27.2434 27.1374 27.2434 6.8454-6.872L79.0113 75l27.1377-27.243Z"
    />
  </Icon>
);

export default memo(WarningIcon);
